export default "__VITE_ASSET__BnoYr1Vq__"